export const ROUTE_START_PAGE = "/";
export const ROUTE_RETAIL_EXPERIENCE = "/retail-experience";
export const ROUTE_RETAIL_EXPERIENCE_CART = "/retail-experience-cart";
export const ROUTE_LIFESTYLE = "/lifestyle";
export const ROUTE_DNA_PROFILE = "/dna-profile";
export const ROUTE_BENEFITS = "/benefits";
